<div class="page-content-wrapper">
  <div v-if="loading" class="text-center mt-4">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <div v-else>
    <div class="row mt-0">
      <div class="col-md-12">
        <div class="card rounded-3 shadow border-1">
          <div class="card-body">
            <CustomTable
              :columns="columns"
              :fetchData="get_projects"
              :key="projectsTableKey"
              :hasActions="true"
              tableKey="projects"
              :heading=projectsHeading
              :buttons="headerButtons"
              @button-click="handleHeaderButtonClick"
            >
              <template v-slot:cell-date_created="{ row }">
                <span class="text-xxs">{{ formatDate(row.date_created) }}</span>
              </template>
              <template v-slot:actions="{ row }">
                <button
                  class="btn bg-green rounded-3 secondary-text-dark fw-bold text-white text-xxs shadow btn-sm me-2"
                  @click="viewProject(row.id)"
                >
                  View
                </button>
                <button
                  v-if="role == 'ClientAdmin'"
                  class="btn btn-dark rounded-3 text-white fw-bold btn-sm text-xxs shadow me-2"
                  @click="edit_project(row)"
                >
                  Edit
                </button>
                <button
                  v-if="role == 'ClientAdmin'"
                  class="btn btn-warning rounded-3 text-dark fw-bold btn-sm text-xxs shadow"
                  @click="open_application_status_modal(row)"
                >
                  <i class="fas fa-tasks me-1"></i>Workflow App Status
                </button>
              </template>
            </CustomTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Create Project Modal -->
<div
  class="modal fade"
  id="create_project"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="create_project_label"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3">
      <div class="modal-header border-bottom-0">
        <h5 class="modal-title text-s fw-bold" id="create_project_label">
          Project Details
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="form-group mb-3">
          <input
            type="text"
            v-model="project_name"
            class="form-control text-xs rounded-small p-3 shadow-sm"
            placeholder="Project Name"
          />
          <small
            class="text-danger p-2 text-xxs fw-bold d-none project-name-messages"
            >Please enter a project name</small
          >
          <small
            class="text-danger p-2 text-xxs fw-bold d-none error-messages"
          ></small>
        </div>
        <div class="form-group mb-3">
          <textarea
            v-model="project_description"
            class="form-control h-100 text-xs rounded-small shadow-sm"
            placeholder="Project Description"
            rows="5"
          ></textarea>
          <small
            class="text-danger p-2 text-xxs fw-bold d-none project-description-messages"
            >Please enter a project description</small
          >
        </div>
        <button
          type="button"
          class="btn bg-green float-end shadow secondary-text-dark text-xxs fw-bold"
          @click="create_project"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Copy Link Modal -->
<div
  class="modal fade"
  id="view_link"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="create_link_label"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3">
      <div class="modal-header border-bottom-0">
        <h5 class="modal-title text-s fw-bold" id="create_project_label">
          Onboarding Link
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="form-group mb-3">
          <input
            type="text"
            v-model="onboarding_link"
            class="form-control text-xs rounded-small p-3 shadow-sm"
            placeholder="Link"
            disabled
          />
          <small
            class="text-danger p-2 text-xxs fw-bold d-none project-name-messages"
          ></small>
          <small class="text-danger p-2 text-xxs fw-bold" v-if="error_messages"
            >{{ error_messages }}</small
          >
          <small class="text-succes p-2 text-xxs fw-bold" v-if="success_message"
            >{{ success_message }}</small
          >
        </div>
        <button
          type="button"
          class="btn bg-green float-end shadow text-xxs fw-bold"
          @click="copy_onboarding_link"
        >
          Copy link
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Edit Project Modal -->
<div
  class="modal fade"
  id="edit_project_modal"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="edit_project_modal_label"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3">
      <div class="modal-header border-bottom-0">
        <h5 class="modal-title text-s fw-bold" id="edit_project_modal_label">
          Edit Project Details
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div class="form-group mb-3">
          <input
            type="text"
            v-model="project_name"
            class="form-control text-xs rounded-small p-3 shadow-sm"
            placeholder="Project Name"
          />
          <small
            class="text-danger p-2 text-xxs fw-bold d-none project-name-messages"
            >Please enter a project name</small
          >
          <small
            class="text-danger p-2 text-xxs fw-bold d-none error-messages"
          ></small>
        </div>
        <div class="form-group mb-3">
          <textarea
            v-model="project_description"
            class="form-control text-xs rounded-small shadow-sm"
            placeholder="Project Description"
          ></textarea>
          <small
            class="text-danger p-2 text-xxs fw-bold d-none project-description-messages"
            >Please enter a project description</small
          >
        </div>
        <button
          type="button"
          class="btn bg-green float-end shadow secondary-text-dark text-xxs fw-bold"
          @click="update_project"
        >
          Save Changes
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Application Status Management Modal -->
<div
  class="modal fade"
  id="application_status_modal"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  tabindex="-1"
  aria-labelledby="application_status_modal_label"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content bg-white rounded-3">
      <div class="modal-header border-bottom-0">
        <h5
          class="modal-title text-s fw-bold"
          id="application_status_modal_label"
        >
          Workflow Application Status Management
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div
          class="d-flex justify-content-end align-items-center mb-3 border-bottom pb-2"
        >
          <button
            type="button"
            class="btn btn-bg-green btn-sm text-xs shadow-sm rounded-3"
            @click="open_status_form"
          >
            <i class="fas fa-plus me-1"></i>Add Status
          </button>
        </div>

        <div v-if="show_status_form" class="card border rounded-3 p-3 mb-3">
          <div class="row g-2">
            <div class="col-md-5">
              <label
                for="new_status_name"
                class="form-label text-xs text-dark fw-semibold"
                >Status Name</label
              >
              <input
                type="text"
                class="form-control text-xs"
                :placeholder="editing_status ? 'Edit status name' : 'Enter new status name'"
                v-model="new_status_name"
              />
            </div>
            <div class="col-md-3">
              <label
                for="new_status_color"
                class="form-label text-xs text-dark fw-semibold"
                >Status Color</label
              >
              <div class="d-flex align-items-center">
                <input
                  type="color"
                  class="form-control form-control-color border-0 p-0 me-2"
                  id="new_status_color"
                  v-model="new_status_color"
                  title="Choose status color"
                />
                <input
                  type="text"
                  class="form-control text-xxs"
                  v-model="new_status_color"
                  placeholder="#000000"
                  style="max-width: 80px"
                />
              </div>
            </div>
            <div class="col-md-4 d-flex align-items-end pb-1">
              <button
                type="button"
                class="btn btn-bg-green btn-sm me-2 text-xs rounded-3 shadow-sm"
                @click="create_or_update_status"
                :disabled="!new_status_name.trim()"
              >
                <i class="fas fa-save me-1"></i>{{ editing_status ? 'Update' :
                'Add' }}
              </button>
              <button
                type="button"
                class="btn btn-bg-secondary rounded-3 shadow-sm btn-sm text-xs"
                @click="cancel_status_edit"
              >
                <i class="fas fa-times me-1"></i>Cancel
              </button>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th class="text-xs fw-bold">Status Name</th>
                  <th class="text-xs fw-bold">Color</th>
                  <th class="text-xs fw-bold">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="status in project_statuses" :key="status.id">
                  <td class="text-xs">{{ status.status }}</td>
                  <td class="text-xs">
                    <div class="d-flex align-items-center">
                      <div
                        class="rounded-circle me-2 shadow-sm"
                        :style="{ backgroundColor: status.color || '#e9ecef', width: '20px', height: '20px', border: '1px solid #dee2e6' }"
                      ></div>
                      <span>{{ status.color || 'Default' }}</span>
                    </div>
                  </td>
                  <td>
                    <button
                      type="button"
                      class="btn btn-sm btn-bg-green rounded-3 shadow-sm me-1 text-xs"
                      @click="edit_status(status)"
                    >
                      <i class="fas fa-edit"></i> Edit
                    </button>
                    <button
                      :disabled="status?.conditions?.length > 0 || status?.customer_application_count > 0"
                      type="button"
                      class="btn btn-sm btn-bg-danger rounded-3 shadow-sm text-xs"
                      @click="delete_status(status)"
                    >
                      <i class="fas fa-trash"></i> Delete
                    </button>
                  </td>
                </tr>
                <tr v-if="project_statuses.length === 0">
                  <td colspan="2" class="text-center text-muted text-xs">
                    No application statuses found for this project.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
